<template>
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item is-hidden-mobile" href="/">
        <img class="object-fit-contain" src="../assets/img/logo.gif" width="294" height="128" style="max-height: none;">
      </a>
      <a class="navbar-item is-hidden-tablet ml-auto" href="/">
        <img class="object-fit-contain" src="../assets/img/logo.gif" width="150" height="128" style="max-height: none;">
      </a>
  
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" :data-target="`nabvar-${uid}`">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  
    <div :id="`nabvar-${uid}`" class="navbar-menu">
      <div class="navbar-end">
        <a class="navbar-item menu__item" :class="menu['header-class']" :href="menu.href" v-for="menu in menus" :key="menu.label">
          {{menu.label}}
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { getCurrentInstance } from 'vue';

import config from './../config.json';

export default {
  name: 'parts-header',
  setup () {
    const uid = getCurrentInstance().uid;
  // ...
    return {
      uid
    };
  },
  data() {
    return {
      menus: config.MENUS,
    }
  },
}
</script>

<style scoped>
.nav-item {
  transition: 0.4s;
}
.navbar-item:hover {
  color: #333;
}

.contact-btn {
  padding: 10px 80px;
}

/* ハンバーガーナビを上書き */
.navbar-brand {
  align-items: center;
  padding-left: 3%;
}

.navbar-burger:hover {
  background-color: transparent;
}

.navbar-burger span {
  width: 32px;
  height: 2px;
  left: calc(50% - 15px);
}

.navbar-burger span:nth-child(1) {
  top: calc(50% - 10px);
}

.navbar-burger span:nth-child(2) {
  top: calc(50%);
}

.navbar-burger span:nth-child(3) {
  top: calc(50% + 10px);
}

.navbar-burger.is-active span:nth-child(3) {
  transform: translateY(-14px) rotate(-45deg);
}


@media screen and (max-width:1280px) { 

.contact-btn {
  padding: 10px 30px;
}
  .navbar-item.is-size-5 {
  font-size: 16px !important;
}
}

@media screen and (max-width:1023px) { 
  .navbar-brand {
  padding: 0 3%;
}
}

</style>